import React from 'react';

const Spinner = (props) => <div {...props} />;

export default Spinner;
